<template>
  <router-view></router-view>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
export default {
  data: function() {
    return {
      show: ""
    };
  },
  name: "app",
  computed: {
      ...mapState(['curTags','stateTagsList'])
  },
  created: function() {
    // this.$bus.$on("loginResult", name => {
    //   if (name == null) {
    //     this.show = "";
    //   } else {
    //     this.show = name;
    //   }
    // });
  },
  mounted() {
    if (this.user.getToken()) {
      let dataList =this.common.fetch(this.constants.manu_list_key)
      let selectedTag =this.common.fetch(this.constants.selected_tag_key)
      if (dataList) {
        this.$store.commit('setTagsList', dataList)
      }
      if (selectedTag) {
        this.$store.commit('checkedTags', selectedTag)
      }
    } else {
      this.$router.push("/");
    }
  }
};
</script>

<style>
body,
html {
  font-size: 14px;
  margin: 0px;
}
.home {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.el-main {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue